export default __webpack_public_path__ + "static/media/ketodrink-wide@3x.1346335e.jpg";